import { Amplify } from 'aws-amplify';

/**
 * Cognito configuration, replacing src/lib/app-params.js.
 *
 * app-params.js was deleted rather than ported: it read an `access_token` from the URL
 * query string into localStorage, which is a Base44-specific flow and a weaker place to
 * keep a token than Amplify's own storage. Amplify manages token refresh and storage
 * itself.
 *
 * This pool is CareConnect's (the CareOne app), not one of our own — see
 * infra/lib/auth-stack.js. Sign-in is native email/password (Amplify `signIn`), NOT
 * the Cognito Hosted UI: CareConnect's pool has self-service signup enabled at the
 * pool level for CareConnect's own onboarding, and the Hosted UI would surface that
 * "Sign up" link on this site too. A native form (AuthContext.jsx `login()`) never
 * renders one, so there is no `oauth` block here and nothing to configure for it.
 *
 * These values are inlined at BUILD time by Vite. Changing one requires a rebuild,
 * not just a redeploy. They are public by nature (a user pool ID and client ID are
 * not secrets) — but never put an actual secret in a VITE_ variable.
 */
const requiredEnv = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
};

const missing = Object.entries(requiredEnv)
  .filter(([, v]) => !v)
  .map(([k]) => k);

if (missing.length) {
  // Loud failure by design — a missing value here breaks sign-in, and a silent
  // null would only surface as a confusing error later.
  console.error(
    `Cognito config missing: ${missing.join(', ')}. ` +
      'Set VITE_COGNITO_* variables in the build environment.'
  );
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: requiredEnv.userPoolId,
      userPoolClientId: requiredEnv.userPoolClientId,
    },
  },
});
